// extracted by css-extract-rspack-plugin
export default {"container":"container-FK4mAQ"};